import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import { ref, onMounted, onUnmounted } from 'vue';
import events from '@astina/paloma-common-ui/src/services/EventBus';
import sidebarContext, { SIDEBAR_STATE_CHANGED } from './services/AppSidebarContext';
import PortalAppHeader from "./components/PortalAppHeader.vue";
import AppAlerts from "@astina/paloma-common-ui/src/components/AppAlerts.vue";
import PortalContextSidebar from "./components/PortalContextSidebar.vue";
import AuthenticationExpired from "@astina/paloma-common-ui/src/components/AuthenticationExpired.vue";
import MaintenanceNotice from "@astina/paloma-common-ui/src/components/MaintenanceNotice.vue";
import UserModal from './components/UserModal.vue';
import inventoryListener from "@astina/paloma-shop-common-ui/src/services/InventoryListener";
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const contextSidebarOpen = ref(false);
        const showUserModal = ref(false);
        sidebarContext.$on(SIDEBAR_STATE_CHANGED, () => {
            contextSidebarOpen.value = sidebarContext.isOpen();
        });
        events.$on('app.show-user-modal', () => showUserModal.value = true);
        onMounted(() => inventoryListener.start());
        onUnmounted(() => inventoryListener.stop());
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", {
                id: "app",
                class: _normalizeClass('page--' + _ctx.$route.name?.toString())
            }, [
                _createVNode(PortalAppHeader),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createElementVNode("main", {
                    class: _normalizeClass({ 'main--with-context-sidebar': contextSidebarOpen.value })
                }, [
                    _createVNode(_component_router_view),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createVNode(PortalContextSidebar)
                ], 2),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createVNode(AppAlerts),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createVNode(AuthenticationExpired),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createVNode(MaintenanceNotice),
                _cache[6] || (_cache[6] = _createTextVNode()),
                (showUserModal.value)
                    ? (_openBlock(), _createBlock(UserModal, {
                        key: 0,
                        onClose: _cache[0] || (_cache[0] = ($event) => (showUserModal.value = false))
                    }))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
